/* eslint-disable no-trailing-spaces */
import React from 'react'
import PropTypes, { object } from 'prop-types'

//import withStyles from '@material-ui/core/styles/withStyles'

import moduleStyle from 'assets/jss/moduleStyle.jsx'

//import Slide from '@material-ui/core/Slide';

import toastResponse from 'jslib/toastResponse'
import jquery from 'jquery'
import { EventBus } from 'jslib/eventBus'
/* 
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
}); */

// icons to contact the mechant and the cart icon to open the cart
class ActionComponent extends React.Component {
  constructor() {
    super()
    this.state = {
      showCart: false,
      open: false
    }
  }

  componentDidMount() {
    const $ = jquery
    const vm = this

  }

  componentWillUnmount() {

  }

  callButton(business) {
    if (business.phone) {
      let phone = business.phone
      if (phone.startsWith('+57') == false)
        phone = '+57' + phone
      return (
        <a href={'tel:' + phone} className="callbutton"> <i className="fa fa-phone fa-2x"
          style={{
            color: this.props.detailColour
          }}
        ></i></a>
      )
    }
    return (<span className="disabled"> <i className="fa fa-phone fa-2x"
    style={{
      color: '#999'
    }}
    ></i></span>)
  }

  whatsappButton(business) {
    if (business.whatsapp) {
      let phone = business.whatsapp
      if (phone.startsWith('+')) phone = phone.slice(1)
      if (phone.startsWith('57') == false)
        phone = '57' + phone

      let text = '%F0%9F%91%8B%20Hola%2C%20vengo%20de%20https%3A%2F%2Fzono.cc%20%0ADeseo%20realizar%20el%20siguiente%20pedido%3A%0A'
      let prefix = "whatsapp://send?phone=" + phone
      return (
        <a href={prefix + '&amp;text=' + text} target="_blank" rel="noopener noreferrer" >
          <i className="fa fa-whatsapp fa-2x"
            style={{
              paddingRight: 5,
              color: this.props.detailColour
            }}
          ></i>
        </a>

      )
    }
    return (<span className="disabled"><i className="fa fa-whatsapp fa-2x"
    style={{
      paddingRight: 5,
      color: '#999'
    }}
  ></i></span>)
  }

  facebookButton(business) {
    if (business.facebook) {
      return (
        <a href={business.facebook}
          target="_blank" rel="noopener noreferrer"
        >
          <i className="fa fa-facebook fa-2x"
            style={{
              paddingRight: 5,
              color: this.props.detailColour
            }}
          ></i>

        </a>
      )
    }
    return (<span className="disabled"><i className="fa fa-facebook fa-2x"
    style={{
      paddingRight: 5,
      color: '#999'
    }}
  ></i></span>)
  }

  instagramButton(business) {
    if (business.instagram) {
      return (
        <a href={business.instagram}
          target="_blank" rel="noopener noreferrer"
        >
          <i className="fa fa-instagram fa-2x"
            style={{
              paddingRight: 5,
              color: this.props.detailColour
            }}
          ></i>
        </a>
      )
    }
    return (<span className="disabled"><i className="fa fa-instagram fa-2x"
    style={{
      paddingRight: 5,
      color: '#999'
    }}
  ></i></span>)
  }

  mailtoButton(business) {
    return (
      <a href={"mailto:" + business.email}
        target="_blank" rel="noopener noreferrer"
      >
        <img src="/images/mailto.png" height={25} ></img></a>
    )
  }


  render() {
    const business = this.props.business

    //console.log('render with', this.props)

    return (
      <div className="row actions-row">
        <div className="col-2" ></div>
        <div className="col-8 contact-icons"
          style={{
            marginTop: 5,
            paddingTop: 5
          }}
        >
          <div style={{
            display: 'flex',
            justifyContent: 'space-between'
          }} >
            {this.whatsappButton(business)}

            {this.facebookButton(business)}

            {this.instagramButton(business)}
            {this.callButton(business)}

          </div>


        </div>

        <div className="col-2" ></div>
      </div>
    )
  }

}

ActionComponent.propTypes = {
  //classes: PropTypes.object.isRequired,
  //theme: PropTypes.object.isRequired,
  business: PropTypes.object.isRequired,
}
export default ActionComponent

//export default withStyles(moduleStyle, { withTheme: true })(ActionComponent)
